import { Link as RLink, NavLink as RNavLink } from "react-router-dom";
import { useLang } from "@/i18n";

const localize = (lp, to) =>
  typeof to === "string" && to.startsWith("/") && !to.startsWith("/admin") ? lp(to) : to;

export const Link = ({ to, ...props }) => {
  const { lp } = useLang();
  return <RLink to={localize(lp, to)} {...props} />;
};

export const NavLink = ({ to, ...props }) => {
  const { lp } = useLang();
  return <RNavLink to={localize(lp, to)} {...props} />;
};
